import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import CreateExperiment from "./pages/CreateExperiment";
import ViewExperiment from "./pages/ViewExperiment";
import SignupPage from "./pages/SignupPage";
import ChangePassword from "./pages/ChangePassword";
import Faq from "./pages/Faq";
import GoogleAuthCallback from "./pages/GoogleAuthCallback";
import Profile from "./pages/profile";
import Payment from "./pages/payment";
import Editor from "./pages/Editor"; // ✅ editor page

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim();

function App() {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [passwordChangeRequired, setPasswordChangeRequired] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    async function verifyToken() {
      const token = localStorage.getItem("jwt_token");

      if (!token) {
        setIsLoggedIn(false);
        setPasswordChangeRequired(false);
        localStorage.removeItem("user_id");
        localStorage.removeItem("passwordChangeRequired");
        return;
      }

      try {
        const res = await fetch(`${BACKEND_URL}/api/auth/verify-token`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
          signal: controller.signal,
        });

        if (res.ok) {
          const data = await res.json();
          const flag = data.flag === 1;

          setIsLoggedIn(true);
          setPasswordChangeRequired(flag);

          localStorage.setItem("user_id", data.user_id);
          localStorage.setItem(
            "passwordChangeRequired",
            flag ? "true" : "false"
          );
        } else {
          handleLogout();
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          handleLogout();
        }
      }
    }

    function handleLogout() {
      setIsLoggedIn(false);
      setPasswordChangeRequired(false);
      localStorage.removeItem("jwt_token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("passwordChangeRequired");
    }

    if (location.pathname !== "/google-auth") {
      verifyToken();
    }

    return () => controller.abort();
  }, [location.pathname]);

  if (isLoggedIn === null && location.pathname !== "/google-auth") {
    return <div>Loading...</div>;
  }

  if (
    isLoggedIn &&
    passwordChangeRequired &&
    location.pathname !== "/change-password"
  ) {
    return <Navigate to="/change-password" replace />;
  }

  return (
    <Routes>
      {/* Public */}
      <Route
        path="/"
        element={isLoggedIn ? <Navigate to="/dashboard" replace /> : <Login />}
      />
      <Route path="/register" element={<Register />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/google-auth" element={<GoogleAuthCallback />} />

      {/* Protected */}
      <Route
        path="/dashboard"
        element={isLoggedIn ? <Dashboard /> : <Navigate to="/" replace />}
      />
      <Route
        path="/createexperiment"
        element={isLoggedIn ? <CreateExperiment /> : <Navigate to="/" replace />}
      />
      <Route
        path="/viewexperiment"
        element={isLoggedIn ? <ViewExperiment /> : <Navigate to="/" replace />}
      />

      {/* ✅ Editor route */}
      <Route
       path="/editor/:experimentId"
       element={isLoggedIn ? <Editor /> : <Navigate to="/" replace />}
/>

      <Route
        path="/faq"
        element={isLoggedIn ? <Faq /> : <Navigate to="/" replace />}
      />
      <Route
        path="/change-password"
        element={isLoggedIn ? <ChangePassword /> : <Navigate to="/" replace />}
      />
      <Route
        path="/profile"
        element={isLoggedIn ? <Profile /> : <Navigate to="/" replace />}
      />
      <Route
        path="/payment"
        element={isLoggedIn ? <Payment /> : <Navigate to="/" replace />}
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />

      

    </Routes>
  );
}

export default App;
